import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Avatar,
  Divider,
  Link,
  Button,
} from "@mui/material";
import {
  Email,
  Phone,
  LocationCity,
  Public,
  AccessTime,
  Home,
  Verified,
  Person,
  Flag,
  Schedule,
  QrCode2,
} from "@mui/icons-material";
import EditForm from "./editForm";
import { useUpdateVendorMutation } from "slices/usersApi";
import { useParams, useSearchParams } from "react-router-dom";

const InfoItem = ({ icon: Icon, label, value, alignItems = "center" }) => (
  <Grid item>
    <Box display="flex" alignItems={alignItems} mb={1}>
      <Icon style={{ marginRight: 8, color: "#1976d2" }} />
      <Typography variant="body1" fontWeight={500}>
        {label}:
      </Typography>
      <Typography variant="body2" ml={1}>
        {value || "-"}
      </Typography>
    </Box>
  </Grid>
);  

const BasicInfo = ({ profile, qrImage, qrCode, onDataUpdate }) => {
  const [open, setOpen] = useState(false);
  const [updateVendor] = useUpdateVendorMutation();
  const { id } = useParams();

  if (!profile) return null;

  const handleEdit = () => {
    setOpen(true);
  };

  const handleSubmit = async (data) => {
    try {
      await updateVendor({ id, body: data }).unwrap();
      setOpen(false);
       onDataUpdate(); 
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  return (
    <Card>
      <EditForm
        open={open}
        onClose={() => setOpen(false)}
        initialData={profile}
        onSubmit={handleSubmit}
      />
      <CardContent>
        <Typography variant="h5" gutterBottom fontWeight={600}>
          <Person style={{ marginRight: 8, verticalAlign: "middle" }} />
          {profile.name}

          <Button
            style={{ background: "#fff" }}
            startIcon={""}
            onClick={handleEdit}
          >
            Edit
          </Button>
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Grid>
          <InfoItem icon={Email} label="Email" value={profile.email} />
          <InfoItem icon={Phone} label="Mobile" value={profile.mobile} />
          <InfoItem icon={Flag} label="Type" value={profile.type} />
          <InfoItem icon={Verified} label="Status" value={profile.status} />
          <InfoItem
            icon={Verified}
            label="Approval"
            value={profile.approvalStatus}
          />
          <InfoItem icon={Schedule} label="Progress" value={profile.progress} />
          <InfoItem icon={LocationCity} label="City" value={profile.city} />
          <InfoItem icon={Public} label="Country" value={profile.country} />
          <InfoItem
            icon={AccessTime}
            label="Timing"
            value={`${profile.openTime} - ${profile.closeTime}`}
          />
          <InfoItem
            icon={AccessTime}
            label="Created"
            value={new Date(profile.created).toLocaleDateString()}
          />
          <InfoItem
            icon={Home}
            label="Address"
            value={profile.address}
            st
            alignItems="start"
          />
        </Grid>

        <Box
          textAlign="center"
          className="qr-img"
          style={{ position: "absolute", top: "10%", right: "0" }}
        >
          <Typography variant="subtitle1" fontWeight={500} mb={1}>
            <QrCode2 style={{ marginRight: 4, verticalAlign: "middle" }} />
            QR Code
          </Typography>
          <img
            src={qrImage}
            crossOrigin="anonymous"
            alt="QR"
            width="200"
            style={{ borderRadius: 8 }}
          />
          <Box mt={1}>
            <Link href={qrCode} target="_blank" rel="noopener noreferrer">
              Open QR Page
            </Link>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BasicInfo;
